module.exports = __webpack_public_path__ + "static/media/more-inactive.f0768868.svg";